import React from 'react';
import { TeachersDay9to122026 } from '../views';


const SchoolProgrampage = () => {
  return <TeachersDay9to122026/>;
};

export default SchoolProgrampage;